export type Buyer = {
  name: string
  location: string
  minutesAgo: number
}

export const buyers: Buyer[] = [
  { name: 'Oliver Bennett', location: 'Manchester, UK', minutesAgo: 2 },
  { name: 'Charlotte Hughes', location: 'Bristol, UK', minutesAgo: 6 },
  { name: 'Harry Whitfield', location: 'Leeds, UK', minutesAgo: 11 },
  { name: 'Amelia Thornton', location: 'Brighton, UK', minutesAgo: 4 },
  { name: 'George Ashworth', location: 'Nottingham, UK', minutesAgo: 9 },
  { name: 'Sophie Carwright', location: 'Cambridge, UK', minutesAgo: 3 },
  { name: 'William Pemberton', location: 'Oxford, UK', minutesAgo: 14 },
  { name: 'Isabella Hartley', location: 'Bath, UK', minutesAgo: 7 },
  { name: 'Thomas Radcliffe', location: 'Sheffield, UK', minutesAgo: 5 },
  { name: 'Emily Fairbanks', location: 'York, UK', minutesAgo: 12 },
]
